import { Component, ElementRef, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { PageBase, OrderCustomerModel, T4DataSource } from 't4core';
import { Router } from '@angular/router';
import { T4DatatableWidget } from '../../../../t4common';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  styleUrls: ['./PayThrough.css'],
  selector: 'PayThrough',
  templateUrl: './PayThrough.html',
})
export class PayThroughCustomerComponent extends PageBase implements OnInit, OnDestroy {

  public isLoading: boolean = false;
  public showLoadCustomers: boolean = false;
  public onlyActive: boolean = true;
  public txtFilter: FormControl = new FormControl();
  public savedFilter: string = '';


  @ViewChild("tblCustomers", { static: false }) tblCustomers: T4DatatableWidget;
  public customersData: OrderCustomerModel[] = [];

  constructor(el: ElementRef, private router: Router) {
    super(el, "TurboOrder");
  }

  async ngOnInit() {
    this.isLoading = true;
    this.customersData = await this.Api.get<OrderCustomerModel[]>("/TurboOrder/GetCustomersMissingPayThrough");
    this.isLoading = false;
  }



  public gotoCustomer(customer: OrderCustomerModel) {
    this.router.navigateByUrl("/TurboOrder/Customer/" + customer.XalAccountNo);
  }
}
